import { useMemo } from "react";

export default function usePageFilter(items: any, from: any, count: any) {
  return useMemo(() => {
    if (items) {
      return items.slice(from, from + count);
    }
    return items;
  }, [items, from, count]);
}
